import { Modal, Drawer } from "@/components";
import { useDeviceType } from "@/hooks";

import type { FC } from "react";
import type { ModalProps } from "@/components";
import type { IContent } from "./content";

import styles from './index.module.scss';
import Content from "./content";

export type IRiskVerification = ModalProps

const RiskVerification: FC<IRiskVerification & IContent> = ({
  getCertificate,
  startCountdown,
  sendType,
  ...modalProps
}) => {

  const device = useDeviceType()

  return (
    device.isPc ?
      <Modal
        {...modalProps}
        title="Frequent requests"
        className={styles.risk_verification}
        closable={false}
        footer={null}
      >
        <Content sendType={sendType} startCountdown={startCountdown} getCertificate={getCertificate} modalProps={modalProps} />
      </Modal> :
      <Drawer
        title="Frequent requests"
        closeIcon={false}
        closable={false}
        maskClosable={false}
        open={modalProps.isOpen}
        onClose={modalProps.onCancel}
        placement="bottom"
        height={'auto'}
        className={styles.risk_verification}
      >
        <Content sendType={sendType} startCountdown={startCountdown} getCertificate={getCertificate} modalProps={modalProps} />
      </Drawer>
  )
}

export default RiskVerification;
